module.exports = __webpack_public_path__ + "static/media/autoshow.4c0b35cb.png";